import { Languages } from "lucide-react";
import { useT } from "@/lib/i18n";

export default function LangToggle({ compact = false }) {
    const { lang, setLang } = useT();
    const other = lang === "en" ? "es" : "en";
    const label = lang === "en" ? "ES" : "EN";
    return (
        <button
            type="button"
            data-testid="lang-toggle"
            onClick={() => setLang(other)}
            className={`inline-flex items-center gap-1.5 rounded-full border border-white/10 text-slate-200 hover:border-emerald-500/40 hover:text-white transition ${
                compact ? "px-2.5 py-1 text-xs" : "px-3 py-2 text-sm"
            }`}
            aria-label="Toggle language"
            title="English / Español"
        >
            <Languages className="w-3.5 h-3.5" />
            <span>{label}</span>
        </button>
    );
}
